import {useEffect, useState} from "react";
import {findGenders} from "../api/apiClient";

export const useGenders = () => {
    const [genders, setGenders] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        const genders = findGenders(abortController.signal);

        genders
            .then(
                (data) => {
                    const genders = data;

                    setGenders(genders)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, []);

    return {genders : genders};
};